import Loadable, {
  LoadableComponent,
  LoadingComponentProps,
} from 'react-loadable';
import Messages from './messages';
import Contact from './contact';
import Browse from './browse';
import Explore from './explore';
import FindExperts from './findExperts';
import Reports from './reports';
import Profile from './profile';
import Project from './project';
import Projects from './projects';
import ProjectDetails from './projectDetails';
import ClientProjectDetails from './clientProjectDetails';
import ClientProjectList from './clientProjectList';
import PrivateInvitation from './privateInvitation';
import InvitationTerms from './invitationTerms';
import SignUpWelcome from './signUpWelcome';
import ExpertSignUp from './expertSignUp';
import ClientSignUp from './clientSignUp';
import ExpertApplication from './expertApplication';
import OrganisationDashboard from './organisationDashboard';
import PaymentSettings from './paymentSettings';
import ExploreAdvancedHelp from './exploreAdvancedHelp';
import ExploreAvailability from './exploreAvailability';
import Calendar from './calendar';
import Partners from './partners';
import Login from './login';
import SsoLogin from './ssoLogin';
import RequestResetPassword from './requestResetPassword';
import ResetPassword from './resetPassword';
import UnsubscribeConfirm from './unsubscribe-confirm';
import UnsubscribeError from './unsubscribe-error';
import AvailabilityError from './availabilityError';
import AvailabilityConfirmation from './availabilityConfirmation';
import FeedbackProjectRecommendation from './feedbackProjectRecommendation';
import Invoices from './invoices';
import ExpertVerification from './expertVerification';
import CreateProject from './createProject';
import EditProject from './editProject';
import TimesheetDetails from './timesheetDetails';
import PaymentDashboard from './paymentDashboard';
import ApproveContractOffer from './approveContractOffer';
import ReviewTimesheetAnonymously from './reviewTimesheetAnonymously';
import ExpertProfileBuilder from './expertProfileBuilder';
import ContractList from './contractList';
import ExpertsToReview from './expertsToReview';
import ContactDetails from './expertSettings/contactDetails';
import Insurance from './expertSettings/insurance';
import PaymentMethod from './expertSettings/paymentMethod';
import ProfileVisibility from './expertSettings/profileVisibility';
import Tax from './expertSettings/tax';
import YourBusiness from './expertSettings/yourBusiness';
import ClientContractDetails from './clientContractDetails';
import Legal from './legal';
import { Loader } from 'shared/legacy';
import { RouteComponentProps } from 'react-router-dom';

export interface PagesType {
  Messages: typeof Messages & LoadableComponent;
  Contact: typeof Contact &
    LoadableComponent &
    React.Component<LoadingComponentProps>;
  Browse: typeof Browse &
    LoadableComponent &
    React.Component<LoadingComponentProps>;
  Explore: typeof Explore &
    LoadableComponent &
    React.Component<RouteComponentProps>;
  FindExpertsPage: typeof FindExperts &
    LoadableComponent &
    React.Component<RouteComponentProps>;
  Reports: typeof Reports &
    LoadableComponent &
    React.Component<RouteComponentProps>;
  Profile: typeof Profile &
    LoadableComponent &
    React.Component<RouteComponentProps>;
  Project: typeof Project &
    LoadableComponent &
    React.Component<RouteComponentProps>;
  Projects: typeof Projects &
    LoadableComponent &
    React.Component<RouteComponentProps>;
  ProjectDetails: typeof ProjectDetails &
    LoadableComponent &
    React.Component<RouteComponentProps>;
  ClientProjectDetails: typeof ClientProjectDetails &
    LoadableComponent &
    React.Component<RouteComponentProps>;
  ClientProjectList: typeof ClientProjectList &
    LoadableComponent &
    React.Component<RouteComponentProps>;
  PrivateInvitation: typeof PrivateInvitation &
    LoadableComponent &
    React.Component<RouteComponentProps>;
  InvitationTerms: typeof InvitationTerms &
    LoadableComponent &
    React.Component<RouteComponentProps>;
  SignUpWelcome: typeof SignUpWelcome &
    LoadableComponent &
    React.Component<RouteComponentProps>;
  ExpertSignUp: typeof ExpertSignUp &
    LoadableComponent &
    React.Component<RouteComponentProps>;
  ClientSignUp: typeof ClientSignUp &
    LoadableComponent &
    React.Component<RouteComponentProps>;
  ExpertApplication: typeof ExpertApplication &
    LoadableComponent &
    React.Component<RouteComponentProps>;
  OrganisationDashboard: typeof OrganisationDashboard &
    LoadableComponent &
    React.Component<RouteComponentProps>;
  PaymentSettings: typeof PaymentSettings &
    LoadableComponent &
    React.Component<RouteComponentProps>;
  ExploreAdvancedHelp: typeof ExploreAdvancedHelp &
    LoadableComponent &
    React.Component<RouteComponentProps>;
  ExploreAvailability: typeof ExploreAvailability &
    LoadableComponent &
    React.Component<RouteComponentProps>;
  Calendar: typeof Calendar &
    LoadableComponent &
    React.Component<RouteComponentProps>;
  Partners: typeof Partners &
    LoadableComponent &
    React.Component<RouteComponentProps>;
  Login: typeof Login &
    LoadableComponent &
    React.Component<RouteComponentProps>;
  SsoLogin: typeof SsoLogin &
    LoadableComponent &
    React.Component<RouteComponentProps>;
  RequestResetPassword: typeof RequestResetPassword &
    LoadableComponent &
    React.Component<RouteComponentProps>;
  ResetPassword: typeof ResetPassword &
    LoadableComponent &
    React.Component<RouteComponentProps>;
  UnsubscribeConfirm: typeof UnsubscribeConfirm &
    LoadableComponent &
    React.Component<RouteComponentProps>;
  UnsubscribeError: typeof UnsubscribeError &
    LoadableComponent &
    React.Component<RouteComponentProps>;
  AvailabilityError: typeof AvailabilityError &
    LoadableComponent &
    React.Component<RouteComponentProps>;
  AvailabilityConfirmation: typeof AvailabilityConfirmation &
    LoadableComponent &
    React.Component<RouteComponentProps>;
  FeedbackProjectRecommendation: typeof FeedbackProjectRecommendation &
    LoadableComponent &
    React.Component<RouteComponentProps>;
  Invoices: typeof Invoices &
    LoadableComponent &
    React.Component<RouteComponentProps>;
  ExpertVerification: typeof ExpertVerification &
    LoadableComponent &
    React.Component<RouteComponentProps>;
  CreateProject: typeof CreateProject &
    LoadableComponent &
    React.Component<RouteComponentProps>;
  EditProject: typeof EditProject &
    LoadableComponent &
    React.Component<RouteComponentProps>;
  TimesheetDetails: typeof TimesheetDetails &
    LoadableComponent &
    React.Component<RouteComponentProps>;
  PaymentDashboard: typeof PaymentDashboard &
    LoadableComponent &
    React.Component<RouteComponentProps>;
  ApproveContractOffer: typeof ApproveContractOffer &
    LoadableComponent &
    React.Component<RouteComponentProps>;
  ReviewTimesheetAnonymously: typeof ReviewTimesheetAnonymously &
    LoadableComponent &
    React.Component<RouteComponentProps>;
  ExpertProfileBuilder: typeof ExpertProfileBuilder &
    LoadableComponent &
    React.Component<RouteComponentProps>;
  ContractList: typeof ContractList &
    LoadableComponent &
    React.Component<RouteComponentProps>;
  ExpertsToReview: typeof ExpertsToReview &
    LoadableComponent &
    React.Component<RouteComponentProps>;
  ContactDetails: typeof ContactDetails &
    LoadableComponent &
    React.Component<RouteComponentProps>;
  Insurance: typeof Insurance &
    LoadableComponent &
    React.Component<RouteComponentProps>;
  PaymentMethod: typeof PaymentMethod &
    LoadableComponent &
    React.Component<RouteComponentProps>;
  ProfileVisibility: typeof ProfileVisibility &
    LoadableComponent &
    React.Component<RouteComponentProps>;
  Tax: typeof Tax & LoadableComponent & React.Component<RouteComponentProps>;
  YourBusiness: typeof YourBusiness &
    LoadableComponent &
    React.Component<RouteComponentProps>;
  ClientContractDetails: typeof ClientContractDetails &
    LoadableComponent &
    React.Component<RouteComponentProps>;
  Legal: typeof Legal &
    LoadableComponent &
    React.Component<RouteComponentProps>;
}

/* tslint:disable */
export const pages = {
  Messages: Loadable({
    loader: async () => import(/* webpackChunkName: "messages" */ './messages'),
    loading: Loader,
  }),
  Contact: Loadable({
    loader: () => import(/* webpackChunkName: "contact" */ './contact'),
    loading: Loader,
  }),
  Browse: Loadable({
    loader: () => import(/* webpackChunkName: "browse" */ './browse'),
    loading: Loader,
  }),
  Explore: Loadable({
    loader: () => import(/* webpackChunkName: "explore" */ './explore'),
    loading: Loader,
  }),
  FindExpertsPage: Loadable({
    loader: () =>
      import(/* webpackChunkName: "findExpertsPage" */ './findExperts'),
    loading: Loader,
  }),
  Reports: Loadable({
    loader: () => import(/* webpackChunkName: "reports" */ './reports'),
    loading: Loader,
  }),
  Profile: Loadable({
    loader: () => import(/* webpackChunkName: "profile" */ './profile'),
    loading: Loader,
  }),
  Project: Loadable({
    loader: () => import(/* webpackChunkName: "project" */ './project'),
    loading: Loader,
  }),
  Projects: Loadable({
    loader: () => import(/* webpackChunkName: "projects" */ './projects'),
    loading: Loader,
  }),
  ProjectDetails: Loadable({
    loader: () =>
      import(/* webpackChunkName: "projectDetails" */ './projectDetails'),
    loading: Loader,
  }),
  ClientProjectDetails: Loadable({
    loader: () =>
      import(
        /* webpackChunkName: "clientProjectDetails" */ './clientProjectDetails'
      ),
    loading: Loader,
  }),
  ClientProjectList: Loadable({
    loader: () =>
      import(/* webpackChunkName: "clientProjectList" */ './clientProjectList'),
    loading: Loader,
  }),
  PrivateInvitation: Loadable({
    loader: () =>
      import(/* webpackChunkName: "privateInvitation" */ './privateInvitation'),
    loading: Loader,
  }),
  InvitationTerms: Loadable({
    loader: () =>
      import(/* webpackChunkName: "invitationTerms" */ './invitationTerms'),
    loading: Loader,
  }),
  SignUpWelcome: Loadable({
    loader: () =>
      import(/* webpackChunkName: "SignUpWelcome" */ './signUpWelcome'),
    loading: Loader,
  }),
  ExpertSignUp: Loadable({
    loader: () =>
      import(/* webpackChunkName: "expertSignUp" */ './expertSignUp'),
    loading: Loader,
  }),
  ClientSignUp: Loadable({
    loader: () =>
      import(/* webpackChunkName: "clientSignUp" */ './clientSignUp'),
    loading: Loader,
  }),
  ExpertApplication: Loadable({
    loader: () =>
      import(/* webpackChunkName: "expertApplication" */ './expertApplication'),
    loading: Loader,
  }),
  OrganisationDashboard: Loadable({
    loader: () =>
      import(/* webpackChunkName: "organisation" */ './organisationDashboard'),
    loading: Loader,
  }),
  PaymentSettings: Loadable({
    loader: () => import(/* webpackChunkName: "payment" */ './paymentSettings'),
    loading: Loader,
  }),
  ExploreAdvancedHelp: Loadable({
    loader: () =>
      import(
        /* webpackChunkName: "explore-advanced-help" */ './exploreAdvancedHelp'
      ),
    loading: Loader,
  }),
  ExploreAvailability: Loadable({
    loader: () =>
      import(
        /* webpackChunkName: "explore-availability" */ './exploreAvailability'
      ),
    loading: Loader,
  }),
  Calendar: Loadable({
    loader: () => import(/* webpackChunkName: "calendar" */ './calendar'),
    loading: Loader,
  }),
  Partners: Loadable({
    loader: () => import(/* webpackChunkName: "partners" */ './partners'),
    loading: Loader,
  }),
  Login: Loadable({
    loader: () => import(/* webpackChunkName: "login" */ './login'),
    loading: Loader,
  }),
  SsoLogin: Loadable({
    loader: () => import(/* webpackChunkName: "ssoLogin" */ './ssoLogin'),
    loading: Loader,
  }),
  RequestResetPassword: Loadable({
    loader: () =>
      import(
        /* webpackChunkName: "requestResetPassword" */ './requestResetPassword'
      ),
    loading: Loader,
  }),
  ResetPassword: Loadable({
    loader: () =>
      import(/* webpackChunkName: "resetPassword" */ './resetPassword'),
    loading: Loader,
  }),
  UnsubscribeConfirm: Loadable({
    loader: () =>
      import(
        /* webpackChunkName: "unsubscribe-confirm" */ './unsubscribe-confirm'
      ),
    loading: Loader,
  }),
  UnsubscribeError: Loadable({
    loader: () =>
      import(/* webpackChunkName: "unsubscribe-error" */ './unsubscribe-error'),
    loading: Loader,
  }),
  AvailabilityError: Loadable({
    loader: () =>
      import(/* webpackChunkName: "availabilityError" */ './availabilityError'),
    loading: Loader,
  }),
  AvailabilityConfirmation: Loadable({
    loader: () =>
      import(
        /* webpackChunkName: "availabilityConfirmation" */ './availabilityConfirmation'
      ),
    loading: Loader,
  }),
  FeedbackProjectRecommendation: Loadable({
    loader: () =>
      import(
        /* webpackChunkName: "feedback-project-recommendation" */ './feedbackProjectRecommendation'
      ),
    loading: Loader,
  }),
  Invoices: Loadable({
    loader: () => import(/* webpackChunkName: "invoices" */ './invoices'),
    loading: Loader,
  }),
  ExpertVerification: Loadable({
    loader: () =>
      import(
        /* webpackChunkName: "expertVerification" */ './expertVerification'
      ),
    loading: Loader,
  }),
  CreateProject: Loadable({
    loader: () =>
      import(/* webpackChunkName: "create-project" */ './createProject'),
    loading: Loader,
  }),
  EditProject: Loadable({
    loader: () =>
      import(/* webpackChunkName: "edit-project" */ './editProject'),
    loading: Loader,
  }),
  TimesheetDetails: Loadable({
    loader: () =>
      import(/* webpackChunkName: "timesheet-details" */ './timesheetDetails'),
    loading: Loader,
  }),
  PaymentDashboard: Loadable({
    loader: () =>
      import(/* webpackChunkName: "payment-dashboard" */ './paymentDashboard'),
    loading: Loader,
  }),
  ApproveContractOffer: Loadable({
    loader: () =>
      import(
        /* webpackChunkName: "review-timesheet-anonymously" */ './approveContractOffer'
      ),
    loading: Loader,
  }),
  ReviewTimesheetAnonymously: Loadable({
    loader: () =>
      import(
        /* webpackChunkName: "review-timesheet-anonymously" */ './reviewTimesheetAnonymously'
      ),
    loading: Loader,
  }),
  ExpertProfileBuilder: Loadable({
    loader: () =>
      import(
        /* webpackChunkName: "expert-profile-builder" */ './expertProfileBuilder'
      ),
    loading: Loader,
  }),
  ContractList: Loadable({
    loader: () =>
      import(/* webpackChunkName: "contract-list" */ './contractList'),
    loading: Loader,
  }),
  ExpertsToReview: Loadable({
    loader: () =>
      import(/* webpackChunkName: "experts-to-review" */ './expertsToReview'),
    loading: Loader,
  }),
  ContactDetails: Loadable({
    loader: () =>
      import(
        /* webpackChunkName: "settings-contact-details" */ './expertSettings/contactDetails'
      ),
    loading: Loader,
  }),
  Insurance: Loadable({
    loader: () =>
      import(
        /* webpackChunkName: "settings-insurance" */ './expertSettings/insurance'
      ),
    loading: Loader,
  }),
  PaymentMethod: Loadable({
    loader: () =>
      import(
        /* webpackChunkName: "settings-payment-method" */ './expertSettings/paymentMethod'
      ),
    loading: Loader,
  }),
  ProfileVisibility: Loadable({
    loader: () =>
      import(
        /* webpackChunkName: "settings-profile-visibility" */ './expertSettings/profileVisibility'
      ),
    loading: Loader,
  }),
  Tax: Loadable({
    loader: () =>
      import(/* webpackChunkName: "settings-tax" */ './expertSettings/tax'),
    loading: Loader,
  }),
  YourBusiness: Loadable({
    loader: () =>
      import(
        /* webpackChunkName: "settings-your-business" */ './expertSettings/yourBusiness'
      ),
    loading: Loader,
  }),
  ClientContractDetails: Loadable({
    loader: () =>
      import(
        /* webpackChunkName: "client-contract-details" */ './clientContractDetails'
      ),
    loading: Loader,
  }),
  Legal: Loadable({
    loader: () => import(/* webpackChunkName: "legalPage" */ './legal'),
    loading: Loader,
  }),
};
